export const stateConstants = {
  stateCode: 'LA',
  stateCodeSmall: 'la',
  state: 'Louisiana'
};